import KeywordSearch from "./KeywordSearch";
import "./Header.component.scss";
import { ReactComponent as ResearcherIcon } from "../../assets/BRN-Map-Help-Researcher.svg";
import { ReactComponent as LocationIcon } from "../../assets/BRN-Map-Help-Location-NEW.svg";
import { ReactComponent as FocusIcon } from "../../assets/BRN-Map-Help-AreasOfFocus.svg";
import { ReactComponent as FocusIconSub } from "../../assets/BRN-Map-Help-AreasOfFocus-Subcategory.svg";

import { ReactComponent as HelpIcon } from "../../assets/BRN-Map-Help-Icon.svg";

export default function Header({
	selectedGrouping,
	setSelectedGrouping,
	setSelectedNode,
}) {
	const groupingOptions = [
		{ value: "researcher", label: "All" },
		{ value: "focus", label: "Area of Focus" },
		{ value: "location", label: "Location" },
	];

	//Click handler for the help button 
	function helpClickHandler() {
		document.querySelector('.network-map-header--help-modal').classList.add('show');
	}

	//Close Modal 'X' Button
	function modalCloseClickHandler() {
		document.querySelector('.network-map-header--help-modal').classList.remove('show');
	}

	//On click for the mobile expand button
	function mobileSlideClickHandler() {
		document.querySelector('.network-map-header--filters').classList.toggle('shown');
		document.querySelector('.network-map-header--mobile-slide').classList.toggle('open');
	}

	return (
		<div className="basis-full border-b-2 border-black network-map-header">
			<div className="container h-40 mx-auto content-center flex flex-col justify-center network-map-header--container">
				<span className="uppercase font-bold text-sm tracking-tight network-back">
					<a href="https://brn.utoronto.ca/network/" className="text-black network-map-header--breadcrumb">
						&#60; Network
					</a>
				</span>
				<div className="flex width-full space-x-4">
					<h1 className="text-6xl font-bold basis-5/12 network-map-header--title">Researcher Map</h1>
					{/* <div className="network-map-header--line-mobile border-black"></div> */}
					<div className="grid grid-cols-2 space-x-6 basis-7/12 network-map-header--filters">
						<label className="flex flex-col">
							<span className="uppercase font-bold text-sm tracking-tight pb-2 -mt-4 network-map-header--label">
								Sort by
							</span>
							<select
								className="border-2 border-black py-2 px-4"
								value={selectedGrouping}
								onChange={(e) => {
									setSelectedGrouping(e.target.value);
									setSelectedNode(null);
								}}
							>
								{groupingOptions.map((o) => (
									<option key={o.value} value={o.value}>
										{o.label}
									</option>
								))}
							</select>
						</label>
						<KeywordSearch setSelectedNode={setSelectedNode} />
					</div>
					<div className="network-map-header--help-btn-container">
						<label className="uppercase font-bold text-sm tracking-tight pb-2 -mt-4 pr-4 network-map-header--label">Help</label>
						<button onClick={helpClickHandler}><HelpIcon /></button>
					</div>

					<button className="network-map-header--mobile-slide" onClick={mobileSlideClickHandler}>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16"> <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" /> </svg>
						<span className="sr-only">Expand</span>
					</button>
				</div>
			</div>

			<div id="subscribe__form--overlay" className="wp-container-16 wp-block-group subscribe__form--overlay network-map-header--help-modal" onClick={modalCloseClickHandler}><div className="wp-block-group__inner-container">
				<div className="wp-container-15 wp-block-group subscribe__form--modal network-map-header--help-modal-inner"><div className="wp-block-group__inner-container network-map-header--help-modal-main-container"><div className="obform-block">
					<div className="obform-block__inner">
						<h3>How to navigate the researcher map</h3></div>
				</div>

					<figure className="wp-block-image size-full close__btn" onClick={modalCloseClickHandler}><img src="https://brn.staging-001.dev/wp-content/uploads/2022/04/close.svg" alt="" className="wp-image-1778" /></figure>

					<div className="network-map-header--help-modal-container grid grid-cols-2 space-x-">
						<div className="flex flex-col col-1">
							<h4>LEGEND</h4>
							<p className="help-modal-p"><ResearcherIcon /> <span>Researcher</span></p>
							<p className="help-modal-p"><LocationIcon /> <span>Location</span></p>
							<p className="help-modal-p"><FocusIcon /> <span>Area of Focus: <br />Main Category</span></p>
							<p className="help-modal-p"><FocusIconSub /> <span>Area of Focus: <br />Subcategory</span></p>

							<h4 className="help-modal-p-a-title">QUESTIONS?</h4>
							<p className="help-modal-p-a">Email us at <br /><a href="mailto:brn.utoronto.ca"><strong>brn.utoronto.ca</strong></a></p>
						</div>
						<div className="flex flex-col col-2">
							<h4>INSTRUCTIONS</h4>
							<ul className="help-modal--ul">
								<li>Interact with the 3D map by clicking, dragging, and scrolling</li>
								<li>In the top white toolbar, filter by location or areas of focus by using the drop down. Search for specific researchers in the search bar.</li>
								<li>Click on a researcher to view their connections as well as their bio.</li>
								<li>Select a location to see its connected researchers.</li>
								<li>Click on an area of focus to view its subcategories and connected researchers. Once selected, further filtering is available by using the checkboxes in the sidebar.</li>
							</ul>
						</div>
					</div>
				</div></div>
			</div></div>

		</div>


	);
}
